<template>
  <CustomMarker
    :class="`custom-marker ${isSelectedOrHighlighted ? 'highlighted' : ''} ${property.latlng ? '' : 'd-none'}`"
    :options="options"
    :style="`opacity:1;z-index:99;`"
    @click.stop="click"
    @mouseover.stop="highlight"
    @mouseout.stop="unhighlight"
  >
    <CustomMarkerIcon
      :icon-name="iconName"
      :color="color"
    />
  </CustomMarker>
</template>

<script>
import {CustomMarker} from "vue3-google-map";
import CustomMarkerIcon from "@/components/common/CustomMarkerIcon.vue";
import {Property,ViolationStatus} from "@/models/Property";

export default {
  components: {
    CustomMarker,
    CustomMarkerIcon
  },
  props: {
    property: Property,
    selectedId: String
  },
  computed: {
    options() {
      return {
        title: this.property.addressFormatted,
        position: this.property.latlng,
        optimized: true
      };
    },
    isSelectedOrHighlighted() {
      return this.selected || this.$ui.isHighlighted(this.property.id);
    },
    selected() {
      return this.selectedId === this.property.id;
    },
    config() {
      const violations = this.property.violations;
      switch (violations.status) {
        case ViolationStatus.clear:
          return {
            color: '33A852',
            icon: 'check-lg'
          };
        case ViolationStatus.violation:
          return {
            color: 'ea4345',
            // icon: 'x-lg'
          };
        case ViolationStatus.unknown:
          return {
            color: '6c757d',
            icon: 'plus-lg'
          };
      }
      return {
        color: '6c757d',
        icon: 'x-lg'
      };
    },
    iconName() {
      return this.config.icon;
    },
    color() {
      return this.config.color;
    }
  },
  methods: {
    click() {
      this.$router.push({
        name: 'violation-detail',
        params: {selectedViolationId: this.property.id}
      });
    },
    highlight() {
      this.$ui.setHighlighted(this.property.id, 'map');
    },
    unhighlight() {
      this.$ui.clearHighlighted('map');
    }
  }
}
</script>

<style>
.custom-marker {
  z-index: 1;
  transition: z-index 0ms linear 250ms;
}
.custom-marker>.custom-marker-icon {
  transition: scale 250ms;
}
.custom-marker.highlighted {
  z-index: 100!important;
}
.custom-marker.highlighted>.custom-marker-icon {
  scale: 2;
}
</style>
